<div class="animate-switch-container h-100" [ngSwitch]="thermalStage">
    <div
        class="animate-switch d-flex flex-column h-100"
        *ngSwitchCase="'thermalBuildingDescriptionStage'"
    >
        <cadastreSolaireThermalBuidingDescription
            class="flex-grow-1 overflow-auto"
        ></cadastreSolaireThermalBuidingDescription>
    </div>
    <div class="animate-switch d-flex flex-column h-100" *ngSwitchCase="'thermalSimulationStage'">
        <cadastreSolaireThermalSimulation
            class="flex-grow-1 overflow-auto"
        ></cadastreSolaireThermalSimulation>
    </div>
</div>
